/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, ILanding, ILandingSection, ITabContent, LANDING_TYPE_CONTENT, TabsContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { TabsPrimitive } from "../../primitive"
import { IDataComponentsProps } from "../DataComponents"
import { setHorizontalAlignToCSSRule } from "../Section"

/* Protopia Ecosystem component */
export interface ISectionTabsProps extends IDataComponentsProps  {
   
}
const SectionTabs = (props: ISectionTabsProps): JSX.Element => { 
    const [section, setSection] = useState<ILandingSection>(props.section)    
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections.find(s => s.id === props.section.id)!                            
                if( JSON.stringify( sec ) !== JSON.stringify( section ) ) { 
                    setSection(() => { return sec })
                    addCSSClass(
                        `section-tabs-container-${props.section.id}`,
                        `.section-tabs-container-${props.section.id} {
                            ${setHorizontalAlignToCSSRule(props.section.vertical_align || ALIGN.MIDDLE )};
                            .bp5-tab-panel {
                                width: 100%;
                            }
                        }`
                    )
                }
            }, 
            {} 
        )
        return () => {
            unsubscribe();
            removeCSSClass( `section-tabs-container-${props.section.id}` )
        };
    }, [])
    const composition = useComposition( section ) 

    const primitive: TabsContent = {
        items: props.data.map(meat => {
            return {
                id: meat.id,
                panel: [ meat ],
                title: <div className="">
                    { meat.title || meat.defaultTitle || meat.id }
                </div>,
            }as ITabContent 
        }),
        vertical: section.isVertical,
        type: LANDING_TYPE_CONTENT.TABS, 
        tabs_design_type:section.tabs_design_type, // TAB_DESIGN_TYPE.PORTHOLE, 
        id : section.id, 
        className: `landing-section-${section.isVertical ? "vertical" : "horizontal"}-tabs `,
        "data-primitive-type" : "section-tabs",
        position: {}

    }

    
    return <div 
        className={ `landing-data-components-container landing-edit-cont section-columns p-0 ${section.className || ""} section-tabs-container-${props.section.id}` }  
        style={{...section.dstyle, }} 
        data-proportia={composition.proportia.join(",")}
    >
        <TabsPrimitive primitive={{ ...primitive as any }} />
    </div>
}
export default SectionTabs